import { Component, OnInit, OnChanges, OnDestroy, Input, Output, ViewChild, EventEmitter, AfterContentInit } from '@angular/core';
import { Form, FormGroup } from '@angular/forms';
// ngrx store
import { Store } from '@ngrx/store';
import { Subscription, interval } from 'rxjs';
import { take, map, takeWhile } from 'rxjs/operators';

// service
import { LoginService } from '../../../../shared/services/login.service';
import { PriceService } from '../../../services/price.service';
// models
import { AppState } from '../../../models/app-state.interface';
import { BookerItem } from '../../../models/booking.interface';
import { BookingInitState } from '../../../models/booking-reducer.interface';
import { UserInitState } from '../../../../shared/models/user-reducer.interface';
import { ErrorHandler } from '../../../../shared/services/error-handler.service';
// globals
import { COUNTRY_CODES, EMAIL_PATTERN } from '../../../../shared/globals';

declare var ga: any;

@Component({
  selector: 'app-booker-form',
  templateUrl: './booker-form.component.html',
  styleUrls: ['./booker-form.component.scss']
})
export class BookerFormComponent implements OnInit, OnChanges, OnDestroy, AfterContentInit {

  @Input() currentBooking;
  @Input() bookingState: BookingInitState;
  @Input() user: UserInitState;
  @Input() appCopy;
  @Input() selectedLanguage;
  @Input() formData;

  @Output()
  validatePhoneNumberParent: EventEmitter<any> = new EventEmitter();

  @Output()
  emailInputChange: EventEmitter<any> = new EventEmitter();

  @ViewChild('form') form;

  @ViewChild('termsFormExpresscheckout') termsFormExpresscheckout;

  private _verifyEmailSubscription: Subscription;
  private _tokenSubscription: Subscription;
  private _emailSentSubscription: Subscription;
  private _validateOTPCodeSubscription: Subscription;
  private _intervalSubscription: Subscription;
  private _bookingStateSubscription: Subscription;
  private _priceSubscription: Subscription;

  private _hasReturnSession: Boolean = false;

  public countryCodes = {
    featured: [...COUNTRY_CODES.featured],
    all: [...COUNTRY_CODES.featured, ...COUNTRY_CODES.all]
  }
  public showLogin = false;
  public loginWithOTP = false;
  public showOTPLoader = false;
  public showSetPassword = false;
  public showLoginLoader = false;
  public isCounting = false;
  public countdown = 1;
  public bookerData: BookerItem = {
    firstName: '',
    lastName: '',
    emailAddress: '',
    emailAddressConfirm: '',
    phoneNumber: '',
    countryCode: '44'
  };
  public userLoggedIn = false;
  public userName = '';
  public bookingType;
  public userHasFirstLastName = true;
  public hasMarketingEnrolment = true;
  public hasSmsWhatsAppEnrolment = true;
  public verifyCustomerStatus;
  public showHasMarketingEnrolment = false;
  public showHasSmsWhatsAppEnrolment = false;
  public bookingAmendSection;
  public emailPattern = EMAIL_PATTERN;
  public lastEmail = '';
  public customerOptIn = false;
  public letterPattern = /^[a-zA-Z]+(?:\s*-\s*[a-zA-Z]+|\s+[a-zA-Z]+)*$/;
  // only 6 numbers
  public otpPattern = /^[0-9]{6}$/;
  // public userLoaded = false;
  public newUserSetPassword = '';
  public OTPLimitReached = false;
  private previousEmail = '';
  private currentEmail = '';
  public validEmail = false;
  public is2FARequired = false;
  public price;
  public priceLoaded;
  public userMarketingPrefference = null;

  showPassword: { [key: string]: boolean } = {
    password: false,
    setNewPassword: false
  };

  constructor(
    private _appStore: Store<AppState>,
    private _pricingService: PriceService,
    private _errorService: ErrorHandler,
    private _loginService: LoginService,
  ) { }
  ngAfterContentInit(): void {
    this.lastEmail = this.bookerData.emailAddress
  }

  ngOnInit() {
    const getFlight = this.getState(this._appStore).flightReducer.flightDetails.flightResponse.flightStatusDetails;
    const departureFlight = this.getState(this._appStore).flightReducer.flightDetails.flightResponse.flightStatusDetails[0];
    const arrivalFlight = this.getState(this._appStore).flightReducer.flightDetails.flightResponse.flightStatusDetails[getFlight.length - 1];
    const departureCountryCode = departureFlight.departureAirport.airportCountryCode;
    const arrivalCountryCode = arrivalFlight.arrivalAirport.airportCountryCode;
    // should be tick by default
    // this.hasMarketingEnrolment = this.getState(this._appStore).bookingReducer.bookingDetails.optedInViaBanner;

    let departureCountryInfo: any;
    let arrivalCountryInfo: any;
    for (let i = 0; i < this.countryCodes.all.length; i++) {
      const country = this.countryCodes.all[i];
      if (departureCountryCode === country.countryCodeName) {
        departureCountryInfo = country;
      }
      if (arrivalCountryCode === country.countryCodeName) {
        arrivalCountryInfo = country;
      }
    }

    this.bookerData.countryCode = departureCountryInfo ? departureCountryInfo.countryCode : arrivalCountryInfo ? arrivalCountryInfo.countryCode : this.bookerData.countryCode;
    this.countryCodes.featured = [];
    if (departureCountryInfo && arrivalCountryInfo) {
      if (departureCountryInfo.countryCode === arrivalCountryInfo.countryCode) {
        this.countryCodes.featured.push(departureCountryInfo)
      }
      else {
        if (arrivalCountryInfo) this.countryCodes.featured.push(arrivalCountryInfo);
        if (departureCountryInfo) this.countryCodes.featured.push(departureCountryInfo);
      }
    }
    this.bookingAmendSection = this.bookingState.bookingDetails.bookingAmendSection;
    this._hasReturnSession = this.getState(this._appStore).flightFinderReducer.returnSessionString !== null;

    // if user logged in as Guest (no password), show set password
    if (this.user.userDetails.userLoggedIn && this.user.userDetails.userRole === 'GUEST') {
      this.showSetPassword = true;
      this._appStore.dispatch({ type: 'UPDATE_BOOKER_EMAIL', payload: this.user.userDetails.userEmail });
    }

    this._verifyEmailSubscription = this._loginService.validateUserSubject$
      .subscribe(res => {

        this.showLogin = false;
        this.showSetPassword = false;
        this.userLoggedIn = false;
        this.userName = '';
        this.hasMarketingEnrolment = res.hasMarketingEnrolment;
        if (res.verifyCustomerStatus !== 1) {
          this.hasMarketingEnrolment = true;
        }
        this.showHasMarketingEnrolment = res.hasMarketingEnrolment;
        this.showHasSmsWhatsAppEnrolment = res.hasSmsWhatsAppEnrolment;
        this.hasMarketingEnrolment = true;
        this.hasSmsWhatsAppEnrolment = true;
        // if (this.lastEmail !== this.bookerData.emailAddress) {
        //   this.lastEmail = this.bookerData.emailAddress;
        // } else {
        //   this.hasMarketingEnrolment = res.hasMarketingEnrolment;
        // }
        this.verifyCustomerStatus = res.verifyCustomerStatus;
        this.is2FARequired = res.is2FARequired;
        this._appStore.dispatch({ type: 'UPDATE_2FA_AUTH', payload: res.is2FARequired });
        this._appStore.dispatch({ type: 'UPDATE_MARKETING_ENROLMENT', payload: true });
        this._appStore.dispatch({ type: 'UPDATE_SMS_WHATSAPP_ENROLMENT', payload: true });
        this._appStore.dispatch({ type: 'UPDATE_USER_STATUS', payload: res.verifyCustomerStatus });

        // if email matches an account with password, show login panel
        if (res.userLoginStatus === 1) {
          this.showLogin = true;
          if (this.previousEmail && this.previousEmail !== this.currentEmail) {
            this.OTPLimitReached = false;
          }
          this.previousEmail = this.currentEmail;
          this.userName = res.firstName;
        }

        if (res.userLoginStatus === 2) {
          this.showSetPassword = true;
          this.loginWithOTP = false;
          this.OTPLimitReached = false;
        }

        // if email doesn't match any account, show set password
        if (res.userLoginStatus === 3) {
          this.showSetPassword = true;
          this.loginWithOTP = false;
          this.OTPLimitReached = false;
        }

      });

    this._priceSubscription = this._appStore.select('priceReducer')
      .subscribe((price: any) => {
        this.price = price.price;

        if (Object.keys(this.price).length > 0) {
          this.priceLoaded = true;
        }




      });

    this._tokenSubscription = this._loginService.tokenSubject$
      .subscribe(token => {
        this.showLoginLoader = false;

        const is2FARequired = this.getState(this._appStore).userReducer.userDetails.is2FARequired;
        if (token === 'payment_login' && is2FARequired) {
          const data = {
            text: "Email sent!",
            type: "info",
            icon: "alert",
            sticky: false,
          };
          this._errorService.handleCustomInfo(data);
          this.loginWithOTP = true;
          this.startCountDown();
        } else {
          this.sendOtp(this.currentEmail);
        }

        if (token.error) {
          // this.handleErrors();
        }
      },
        err => console.log(err));

    this._emailSentSubscription =
      this._loginService.forgotPasswordEmailSent$.subscribe(
        (emailSent) => {
          this.showOTPLoader = false;

          if (emailSent.error) {
            this.handleErrors(emailSent.error);
            return;
          }

          const data = {
            text: "Email sent!",
            type: "info",
            icon: "alert",
            sticky: false,
          };

          if (this.getState(this._appStore).userReducer.userDetails.is2FARequired) {
            data.text = 'OTP sent to phone number!';
          }
          this._errorService.handleCustomInfo(data);
          this.loginWithOTP = emailSent;
          this.startCountDown();
        },
        (err) => console.log(err)
      );

    this._validateOTPCodeSubscription =
      this._loginService.validateOTPCode$.subscribe(
        (res) => {
          this.showLoginLoader = false;
          if (res.error) {
            this.showOTPLoader = false;
          }
        },
        (err) => console.log(err)
      );

    this._bookingStateSubscription = this._appStore.select('bookingReducer')
      .subscribe((bookingState: any) => {
        this.customerOptIn = bookingState.bookingDetails.optedInViaBanner;
      });
    this.setUserValues();
  }

  togglePasswordVisibility(field: string): void {
    this.showPassword[field] = !this.showPassword[field];
  }

  handleErrors(error) {
    this.showOTPLoader = false;
    if (error.validationErrors && error.validationErrors.length > 0) {
      this.OTPLimitReached = error.validationErrors[0] === 'You have reached a limit of OTP resends. Please continue as a guest.';
      this.showLogin = false;
    }
  }

  startCountDown() {
    if (this.isCounting) return;
    this.isCounting = true;
    this.countdown = 59;

    this._intervalSubscription = interval(1000)
      .pipe(
        takeWhile(() => this.countdown > 1),
        map(() => --this.countdown)
      )
      .subscribe({
        complete: () => {
          this.isCounting = false;
          this.countdown = 1;
        },
      });
  }

  stopCountDown() {
    if (this._intervalSubscription) {
      this._intervalSubscription.unsubscribe();
      this.isCounting = false;
      this.countdown = 1;
    }
  }

  skiplogin() {
    this.loginWithOTP = false;
    this.OTPLimitReached = false;
    this.showLogin = false;
    this.stopCountDown();
    ga('send', 'event', 'Vanilla', 'Pay - Info', 'SkipLogin');
  }

  loginWithPassword() {
    this.loginWithOTP = false;
    this.OTPLimitReached = false;
    this.showLogin = true;
    this.stopCountDown();
  }
  // on user changes
  // set user values
  ngOnChanges(changes: any) {
    if (changes.user) {
      if (!changes.user.firstChange) {
        this.user = changes.user.currentValue;
        this.setUserValues();
      }
    }
    this.updateAllLabels(this.appCopy.panelHeader['bookerOtherCountry' + this.selectedLanguage]);
  }

  updateAllLabels(newLabel: string) {
    this.countryCodes.all = this.countryCodes.all.map((country) => ({
      ...country,
      label: newLabel
    }));
  }


  setUserValues() {
    this.userLoggedIn = this.user.userDetails.userLoggedIn;
    this.userHasFirstLastName =
      (this.user.userDetails.currentUser.firstName !== null && typeof this.user.userDetails.currentUser.firstName !== 'undefined')
      && (this.user.userDetails.currentUser.lastName !== null && typeof this.user.userDetails.currentUser.lastName !== 'undefined');

    this.bookingType = this.bookingState.bookingDetails.bookingType;

    if (this.user.userDetails.userLoggedIn) {
      this.showLogin = false;
      this.showLoginLoader = false;
      this.showSetPassword = false;

      // this.hasMarketingEnrolment = true;

      this.showHasMarketingEnrolment = this.user.userDetails.hasMarketingEnrolment;
      this.showHasSmsWhatsAppEnrolment = this.user.userDetails.hasSmsWhatsAppEnrolment;
    }

    if ((this._hasReturnSession && this.currentBooking.bookingUser !== null) || this.bookingType === 'amend') {
      this.bookerData.emailAddress = this.currentBooking.bookingUser.emailAddress;
      this.bookerData.emailAddressConfirm = this.currentBooking.bookingUser.emailAddress;
      this.bookerData.firstName = this.currentBooking.bookingUser.firstName.replace(/^\s+/g, '');
      this.bookerData.lastName = this.currentBooking.bookingUser.lastName.replace(/^\s+/g, '');
      this.bookerData.countryCode = this.currentBooking.bookingUser.countryCode;
      this.bookerData.phoneNumber = this.currentBooking.bookingUser.phoneNumber;
    } else if (this.userLoggedIn) {
      this.bookerData.emailAddress = this.user.userDetails.userEmail;
      this.bookerData.emailAddressConfirm = this.user.userDetails.userEmail;
      this.bookerData.firstName = this.user.userDetails.currentUser.firstName.replace(/^\s+/g, '');
      this.bookerData.lastName = this.user.userDetails.currentUser.lastName.replace(/^\s+/g, '');
      if (this.user.userDetails.currentUser.mobileNumberCountryCode !== '' &&
        this.user.userDetails.currentUser.mobileNumber !== '') {
        this.bookerData.countryCode = this.user.userDetails.currentUser.mobileNumberCountryCode;
        this.bookerData.phoneNumber = this.user.userDetails.currentUser.mobileNumber;
      }
    }

    if (this.formData.set && this.formData.data && !this.userLoggedIn && !(this._hasReturnSession && this.currentBooking.bookingUser !== null)) {
      this.bookerData.emailAddress = this.formData.data.bookerForm.bookerEmail;
      this.bookerData.emailAddressConfirm = this.formData.data.bookerForm.bookerEmailConfirm;
      this.bookerData.firstName = this.formData.data.bookerForm.bookerFirstName?.replace(/^\s+/g, '');
      this.bookerData.lastName = this.formData.data.bookerForm.bookerLastName?.replace(/^\s+/g, '');
      this.bookerData.countryCode = this.formData.data.bookerForm.contactCountryCode;
      this.bookerData.phoneNumber = this.formData.data.bookerForm.contactPhone;
      this.newUserSetPassword = this.formData.data.bookerForm.setPassword;
    }

    // this.userLoaded = true;
  }

  resetValidationExpressCheckout() {
    this.emailInputChange.emit();
    console.log(this.termsFormExpresscheckout);
  }

  verifiyAccount(email) {

    if (!this.userLoggedIn) {
      this._appStore.dispatch({ type: 'UPDATE_BOOKER_EMAIL', payload: email });
      if (this.emailPattern.test(email)) {
        this._pricingService.getPrice();
        // this._loginService.updateUserEmail(email);
        this.validEmail = true;
        this._loginService.updateUserEmail(email);
        this._loginService.validateEmail(email);
        this.currentEmail = email;
      } else {
        this.validEmail = false;
        this.showLogin = false;
        this.userName = '';
        this.form.controls['bookerEmail'].setErrors({ 'pattern': true });
      }
    }
  }

  validatePassword(password) {

    if (password !== '' && password.length < 6) {
      this.form.controls['setPassword'].setErrors({ 'pattern': true });
    }
  }

  validatePhoneNumber(countryCode, phoneNumber) {
    if (phoneNumber !== '') {
      const value = '+' + countryCode + phoneNumber;
      console.log(value)
      this.validatePhoneNumberParent.emit(value);
    }
  }

  inlineLogin(email, password) {
    this.showLoginLoader = true;
    const encodedPassword = encodeURIComponent(password);
    const params = 'grant_type=password&username=' + encodeURIComponent(email) + '&password=' + encodedPassword;
    const storeCookie = true;
    const isGuest = false;

    this.showLoginLoader = true;
    this._loginService.getToken(params, storeCookie, isGuest, email, 'payment_login');
    this._loginService.userHasPassword();
  }

  sendOtp(email) {
    this.currentEmail = email;
    this.previousEmail = this.currentEmail;
    this.showOTPLoader = true;

    const token = this.getState(this._appStore).userReducer.userDetails.userToken;
    if (this.is2FARequired) {
      this._loginService.SendOneTimeLoginCode(email, 'payment', token);
    } else {
      this._loginService.sendOTP(email, null, 'payment');
    }
  }

  inlineOTPLogin(email, otp,) {
    if (otp.toString().length !== 6) {
      return;
    }
    this.showLoginLoader = true;
    this._loginService.validateOTPCode(otp, email, 'payment', this.is2FARequired);
  }

  logout() {
    this.loginWithOTP = false;
    this._loginService.logout();
  }

  trackMarketingOptInConsent(event) {
    this.hasMarketingEnrolment = event;
    this.userMarketingPrefference = event ? 1 : 0;
    this._appStore.dispatch({ type: 'UPDATE_MARKETING_ENROLMENT', payload: event });
  }

  trackSmsWhatsAppOptInConsent(event) {
    this.hasSmsWhatsAppEnrolment = event;
    this._appStore.dispatch({ type: 'UPDATE_SMS_WHATSAPP_ENROLMENT', payload: event });
  }

  // get store state
  getState(store: Store<AppState>): AppState {
    let state: AppState;
    store.pipe(take(1))
      .subscribe(s => state = s);
    return state;
  }

  ngOnDestroy() {
    this._verifyEmailSubscription.unsubscribe();
    this._tokenSubscription.unsubscribe();
    if (this._intervalSubscription) {
      this._intervalSubscription.unsubscribe();
    }
    if (this._emailSentSubscription) {
      this._emailSentSubscription.unsubscribe();
    }
    if (this._validateOTPCodeSubscription) {
      this._validateOTPCodeSubscription.unsubscribe();
    }

    if (this._bookingStateSubscription) {
      this._bookingStateSubscription.unsubscribe();
    }

    if (this._priceSubscription) {
      this._priceSubscription.unsubscribe();
    }
  }

}
